let AppSettings = {
    mainColor: 'brand',
    backgroundColor: 'light-2',
    cardColor: 'light-1',
    currencyOptionFormater: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 2,
        format: '%v' // %s is the symbol and %v is the value
    },
    currencyOptionFormaterNoDecimal: {
        symbol: '€',
        decimal: ',',
        thousand: '.',
        precision: 0,
        format: '%v' // %s is the symbol and %v is the value
    },
    toggleInsteadOfCheckbox: true,
    baremeAccessForAdmin: false,
    tva: 0.21,
    pdfRenderingOptions: `pdf.scale=0.8&emulateScreenMedia=true&waitFor=${encodeURIComponent("#loaded")}`,
    //NO TRAILING SLASH
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000',
};
export default AppSettings;


// WEBPACK FOOTER //
// ./src/utils/app_settings.js